<template>
  <div v-if="availableTrees !== null && availableTrees.length > 0">
    <squircle :clss="'gb-zm-button-button'" />
    <div class="gb-zm-button-button"
            :class="getClass()"
            v-on:click="toggle">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"
           width="36px" height="48px" v-if="$store.getters.state === 'shown'">
        <path d="M0 0h24v24H0V0z" fill="none"/>
        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"
           width="36px" height="48px"  v-if="$store.getters.state === 'back'">
        <path d="M0 0h24v24H0V0z" fill="none"/>
        <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
      </svg>
    </div>
  </div>
</template>

<script type="text/javascript">
import GuestCookie from '@/components/guest-cookie'
import Squircle from '@/components/Squircle'

export default {
  name: 'MainButton',
  components: { Squircle },
  computed: {
    availableTrees () {
      return this.$store.getters.availableTrees
    },
    webchatStep () {
      return this.$store.getters['webchat/step']
    }
  },
  methods: {
    getClass () {
      let clss = 'gb-zm-button-closed'
      if (this.$store.getters.state === 'shown') {
        clss = 'gb-zm-button-open'
      } else if (this.$store.getters.state === 'back') {
        clss = 'gb-zm-button-back'
      }
      return clss
    },
    toggle () {
      this.$store.commit('setNeedCta', false)
      const channelItems = document.querySelectorAll('.gb-zm-channel')
      channelItems.forEach(item => {
        if (this.$store.getters.state === 'shown') {
          item.classList.add('gb-zm-show')
          item.classList.remove('gb-zm-hide')
        } else if (this.$store.getters.state === 'back') {
          item.classList.add('gb-zm-show')
          item.classList.remove('gb-zm-hide')
        } else if (this.$store.getters.state === 'hidden') {
          item.classList.add('gb-zm-hide')
          item.classList.remove('gb-zm-show')
        }
      })

      if (this.$store.getters.state === 'shown') {
        GuestCookie.storeGuest('close', this.$store.getters.account, 'on')
        this.$store.commit('setState', 'hidden')
      } else if (this.$store.getters.state === 'back') {
        if (channelItems.length === 1) {
          this.$store.commit('setState', 'hidden')
          window.GbBot.$store.commit('updateStep', 'button')
        } else {
          this.$store.commit('setState', 'shown')
          window.GbBot.$store.commit('updateStep', 'button')
        }
      } else {
        if (channelItems.length === 1) {
          this.$store.commit('setState', 'back')
          if (channelItems.length === 1) {
            channelItems.forEach(item => {
              item.click()
            })
          }
          window.GbBot.$store.commit('updateStep', 'chatbox')
        } else {
          this.$store.commit('setState', 'shown')
          window.GbBot.$store.commit('updateStep', 'button')
        }
      }
    }
  },
  watch: {
    webchatStep (value, oldValue) {
      if (value === 'chatbox') {
        this.$store.commit('setState', 'webchat')
      }
    }
  },
  created () {
    const autoOpen = this.$store.getters.autoOpen
    const hasBeenClosed = GuestCookie.readGuest(
      'close', this.$store.getters.account)
    if (autoOpen !== null && autoOpen > 0 && hasBeenClosed === null) {
      window.setTimeout(() => {
        if (this.$store.getters.state === 'hidden') {
          this.toggle()
        }
      }, autoOpen * 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: $VUE_APP_FLOA_COLOR;

.gb-zm-button-button {
  border: none;
  border-radius: 33.34%;
  bottom: 20px;
  cursor: pointer;
  filter: drop-shadow(0 5px 10px rgba(0, 127, 248, .5));
  height: 60px;
  position: fixed;
  right: 20px;
  // pointer-events: none;
  width: 60px;
  z-index: 9999;
  clip-path: url(#squircle);

  @media (max-width: 640px) {
    width: 40px;
    height: 40px;
  }

  &:focus {
    outline: none;
  }

  &.gb-zm-button-closed {
    background-image: url("~@/assets/floa-bank/img/open.png");
    background-color: $primary;
    background-size: 55%;
    background-position: center;
    background-repeat: no-repeat;
  }

  &.gb-zm-button-back {
    background: $primary;
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;

    @media (max-width: 640px) {
      position: static;
      display: none;
    }
  }

  &.gb-zm-button-open {
    background: $primary;
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
  }

  svg {
    left: 0px;
    position: relative;
    margin: 6px auto;
    display: block;

    @media (max-width: 640px) {
      margin: 4px auto;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
